import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routes";
import { getEnvVar } from "./utils/env";

const onRedirectCallback = (appState) => {
  console.log('Auth0 redirect callback:', appState);
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={getEnvVar('REACT_APP_AUTH0_DOMAIN')}
    clientId={getEnvVar('REACT_APP_AUTH0_CLIENT_ID')}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: getEnvVar('REACT_APP_AUTH0_AUDIENCE'),
      scope: 'openid profile email'
    }}
    onRedirectCallback={onRedirectCallback}
    useRefreshTokens={false}
    cacheLocation="localstorage"
  >
    <RouterProvider router={router} />
  </Auth0Provider>
);